import React from 'react';
import './index.less';

export interface IABSFieldErrorProps {
  result?: any;
}

const ABSFieldError: React.FC<IABSFieldErrorProps> = props => {
  const { result } = props;
  if (result && result.pass) {
    return null;
  }

  const { msg = '' } = result || {};
  if (!msg) {
    return null;
  }

  return (
    <div className="abs-field-error">
      <div className="abs-field-error-content">{msg}</div>
    </div>
  );
};

export default ABSFieldError;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSField/Error/index.tsx